import React, { ReactNode, createContext, useContext, useMemo } from 'react';

import { useSessionManager } from '../hooks/Auth/useSessionManager';

type AuthContextType = {
  authStatus: boolean;
  setAuthStatus: React.Dispatch<React.SetStateAction<boolean>>;
  loading: boolean;
  clearSession: () => Promise<void>;
};

const AuthContext = createContext<AuthContextType | null>(null);

interface ProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<ProviderProps> = ({ children }) => {
  const { authStatus, setAuthStatus, loading, clearSession } = useSessionManager();

  const contextValue = useMemo(
    () => ({ authStatus, setAuthStatus, loading, clearSession }),
    [authStatus, setAuthStatus, loading, clearSession],
  );

  return <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>;
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};